import React, { useEffect, useState } from 'react'
import heartFill from "../images/Heart-Fill.png";

const LiveWatchers = ({auctionId, user}) => {
    const [liveData, setLiveData] = useState(null);
    
  return (
    <div>
        <img src={heartFill} alt="no found" style={{ height: '16px', width: '18px' }} />
        <span>{liveData && liveData?.watchlist ? liveData?.watchlist : 0}</span>
    </div>
  )
}

export default LiveWatchers